<template>
  <div class="row">
    <div class="col-md-4 col-sm-12">
      <card class="border-0 mb-3" no-body shadow>

        <img class="img-fluid"
             src="../assets/img/swiss_ideas.jpg">
        <div class="px-3 mt-3 pb-3">
          <h6 style="color: #D52B1E" class="text-uppercase">Swiss Pilot Ideas</h6>
          <p class="description mt-3">

            View Ideas from the Swiss Pilot such as <b>Rebutton</b>, <b>Refill yourYoghurt Jar</b> and others!

          </p>

          <base-button tag="a" href="https://ptwist.eu/swiss-pilot-ideas/" target="_blank"
                       style="background-color: #D52B1E; border: 1px solid #D52B1E"
                       class="mt-4 shadow text-white">
            Swiss Pilot Ideas
          </base-button>
        </div>
      </card>
    </div>
    <div class="col-md-4 col-sm-12">
      <card class="border-0 mb-3" no-body shadow>

        <img class="img-fluid"
             src="../assets/img/greek_ideas.jpg">
        <div class="px-3 mt-3 pb-3">
          <h6 style="color: #005bae" class="text-uppercase">Greek Pilot Ideas</h6>
          <p class="description mt-3">

            View Ideas from the Greek Pilot performs a variety of beach cleaning and others.

          </p>

          <base-button tag="a" href="https://ptwist.eu/greek-pilot-ideas" target="_blank"
                       style="background-color: #005bae; border: 1px solid #005bae"
                       class="mt-4 shadow text-white">
            Greek Pilot Ideas
          </base-button>
        </div>
      </card>
    </div>
    <div class="col-md-4 col-sm-12">
      <card class="border-0 mb-3" no-body shadow>

        <img class="img-fluid"
             src="../assets/img/dutch_ideas.jpg">
        <div class="px-3 mt-3 pb-3">
          <h6 style="color: #21468B" class="text-uppercase">Dutch Pilot Ideas</h6>
          <p class="description mt-3">

            View Ideas from the Dutch Pilot such as the <b> Plastic Playground </b>

          </p>

          <base-button tag="a" href="https://ptwist.eu/dutch-pilot-ideas" target="_blank"
                       style="background-color: #21468B; border: 1px solid #21468B"
                       class="mt-4 shadow text-white">
            Dutch Pilot Ideas
          </base-button>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'external-sources'
}
</script>
